export const TIMEZONE_BY_COUNTRY: { [key: string]: string } = {
  GB: 'Europe/London',
  IE: 'Europe/Dublin',
  PT: 'Europe/Lisbon',
  IS: 'Atlantic/Reykjavik',
  ES: 'Europe/Madrid',
  FR: 'Europe/Paris',
  BE: 'Europe/Brussels',
  NL: 'Europe/Amsterdam',
  LU: 'Europe/Luxembourg',
  DE: 'Europe/Berlin',
  CH: 'Europe/Zurich',
  IT: 'Europe/Rome',
  AT: 'Europe/Vienna',
  CZ: 'Europe/Prague',
  PL: 'Europe/Warsaw',
  HU: 'Europe/Budapest',
  SK: 'Europe/Bratislava',
  SI: 'Europe/Ljubljana',
  HR: 'Europe/Zagreb',
  BA: 'Europe/Sarajevo',
  RS: 'Europe/Belgrade',
  ME: 'Europe/Podgorica',
  MK: 'Europe/Skopje',
  AL: 'Europe/Tirane',
  DK: 'Europe/Copenhagen',
  SE: 'Europe/Stockholm',
  NO: 'Europe/Oslo',
  MT: 'Europe/Malta',
  MC: 'Europe/Monaco',
  VA: 'Europe/Vatican',
  SM: 'Europe/San_Marino',
  AD: 'Europe/Andorra',
  GR: 'Europe/Athens',
  RO: 'Europe/Bucharest',
  BG: 'Europe/Sofia',
  FI: 'Europe/Helsinki',
  EE: 'Europe/Tallinn',
  LV: 'Europe/Riga',
  LT: 'Europe/Vilnius',
  UA: 'Europe/Kyiv',
  MD: 'Europe/Chisinau',
  CY: 'Asia/Nicosia',
  BY: 'Europe/Minsk',
}

export const TIMEZONE_BY_STATE_US: { [key: string]: string } = {
  ME: 'America/New_York',
  NH: 'America/New_York',
  VT: 'America/New_York',
  MA: 'America/New_York',
  RI: 'America/New_York',
  CT: 'America/New_York',
  NY: 'America/New_York',
  NJ: 'America/New_York',
  PA: 'America/New_York',
  DE: 'America/New_York',
  MD: 'America/New_York',
  VA: 'America/New_York',
  WV: 'America/New_York',
  NC: 'America/New_York',
  SC: 'America/New_York',
  GA: 'America/New_York',
  FL: 'America/New_York',
  OH: 'America/New_York',
  MI: 'America/Detroit',
  IN: 'America/Indiana/Indianapolis',
  KY: 'America/New_York',
  TN: 'America/New_York',
  AL: 'America/Chicago',
  MS: 'America/Chicago',
  LA: 'America/Chicago',
  AR: 'America/Chicago',
  MO: 'America/Chicago',
  IA: 'America/Chicago',
  MN: 'America/Chicago',
  WI: 'America/Chicago',
  IL: 'America/Chicago',
  TX: 'America/Chicago',
  OK: 'America/Chicago',
  KS: 'America/Chicago',
  NE: 'America/Chicago',
  SD: 'America/Chicago',
  ND: 'America/Chicago',
  MT: 'America/Denver',
  WY: 'America/Denver',
  CO: 'America/Denver',
  NM: 'America/Denver',
  ID: 'America/Denver',
  UT: 'America/Denver',
  AZ: 'America/Phoenix',
  NV: 'America/Los_Angeles',
  CA: 'America/Los_Angeles',
  OR: 'America/Los_Angeles',
  WA: 'America/Los_Angeles',
}

export const TIMEZONE_BY_STATE_AU: { [key: string]: string } = {
  NSW: 'Australia/Sydney',
  VIC: 'Australia/Melbourne',
  QLD: 'Australia/Brisbane',
  SA: 'Australia/Adelaide',
  WA: 'Australia/Perth',
  TAS: 'Australia/Hobart',
  NT: 'Australia/Darwin',
  ACT: 'Australia/Sydney',
}
